import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import {
  MainCard,
  MainCardContent,
  MainCardTitle,
} from "src/components/main-card-type.tsx";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { ContadorDiasResponse } from "../Contador-dias";
const calculatorKey = "contador-dias-uteis";

export const ContadorInputCard = ({
  setResults,
}: {
  setResults: (value: ContadorDiasResponse | null) => void;
}) => {
  const isVerified = useIsVerified();
  const [message, setMessage] = useState<string>("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  function clear() {
    setDataInicio("");
    setDataFinal("");
  }
  function handleSave() {
    saveCalculatorData(calculatorKey, {
      dataInicio,
      dataFinal,
    });
  }
  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setDataInicio((savedData.dataInicio as string) || "");
    setDataFinal((savedData.dataFinal as string) || "");
  }, []);

  function dataAtualInicial() {
    const today = new Date();
    const dia = String(today.getDate()).padStart(2, "0");
    const mes = String(today.getMonth() + 1).padStart(2, "0");
    const ano = String(today.getFullYear());
    const dataFormatada = `${ano}-${mes}-${dia}`;
    setDataInicio(dataFormatada);
  }

  function dataAtualFinal() {
    const today = new Date();
    const dia = String(today.getDate()).padStart(2, "0");
    const mes = String(today.getMonth() + 1).padStart(2, "0");
    const ano = String(today.getFullYear());
    const dataFormatada = `${ano}-${mes}-${dia}`;
    setDataFinal(dataFormatada);
  }

  function calcular() {
    if (!dataInicio) {
      setMessage("Adicione uma data Inicial");
      setResults(null);
      return;
    }
    if (!dataFinal) {
      setMessage("Adicione uma data Final");
      setResults(null);
      return;
    }

    const [anoI, mesI, diaI] = dataInicio.split("-");
    const [anoF, mesF, diaF] = dataFinal.split("-");

    const inicio = new Date(Number(anoI), Number(mesI) - 1, Number(diaI));
    const fim = new Date(Number(anoF), Number(mesF) - 1, Number(diaF));

    const feriadosNacionais = [
      "01-01",
      "21-04",
      "01-05",
      "07-09",
      "12-10",
      "02-11",
      "15-11",
      "25-12",
    ];

    function isFeriado(date: Date) {
      const dia = String(date.getDate()).padStart(2, "0");
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      return feriadosNacionais.includes(`${dia}-${mes}`);
    }

    let diasCorridos = 0;
    let diasUteis = 0;
    let sabados = 0;
    let domingos = 0;
    let feriados = 0;

    let dataAtual = new Date(inicio);

    while (dataAtual <= fim) {
      diasCorridos++;

      const diaSemana = dataAtual.getDay();

      if (isFeriado(dataAtual)) {
        feriados++;
      }

      if (diaSemana === 6) {
        sabados++;
      } else if (diaSemana === 0) {
        domingos++;
      } else if (!isFeriado(dataAtual)) {
        diasUteis++;
      }

      dataAtual.setDate(dataAtual.getDate() + 1);
    }

    const resultado = {
      diasCorridos: diasCorridos,
      diasUteis: diasUteis,
      sabados: sabados,
      domingos: domingos,
      feriados: feriados,
    };
    setResults(resultado);
  }

  return (
    <MainCard>
      <MainCardTitle>Contador de dias Úteis</MainCardTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calcular);
        }}
      >
        <MainCardContent>
          <div className="relative">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="br uto-id"
            >
              Data Ínicio
            </label>
            <button
              onClick={dataAtualInicial}
              type="button"
              className="inline-flex items-center px-3 absolute -top-1.5  right-0 py-1.5 border-r text-sm bg-[#e9ecef] hover:bg-gray-400 rounded-sm"
            >
              Data Atual
            </button>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="mm/dd"
                type="date"
                value={dataInicio}
                onChange={(event) => setDataInicio(event.target.value)}
              />
            </div>
          </div>
          <div className="relative">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Data Final
            </label>
            <button
              onClick={dataAtualFinal}
              type="button"
              className="absolute right-0 -top-1.5 inline-flex items-center px-3 py-1.5 border-r text-sm bg-[#e9ecef] hover:bg-gray-400 rounded-sm"
            >
              Data Atual
            </button>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="mm/dd"
                type="date"
                value={dataFinal}
                onChange={(event) => setDataFinal(event.target.value)}
              />
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>
      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};